import { useEffect } from 'react';
import { CDN_URL } from './constants';

const ScriptLoader = () => {
    useEffect(() => {
        // First, add template attributes to HTML element
        const htmlElement = document.documentElement;
        
        // Check localStorage for collapsed state
        const isCollapsed = localStorage.getItem('sidebarCollapsed') === 'true';

        // Check localStorage for hover state
        const isHovered = localStorage.getItem('sidebarHovered') === 'true';

        // add the core class elements
        htmlElement.classList.add('layout-navbar-fixed', 'layout-menu-fixed', 'layout-compact');

        // Only add collapsed class if stored in localStorage
        if (isCollapsed) {
            htmlElement.classList.add('layout-menu-collapsed');
            htmlElement.classList.remove('layout-menu-expanded');
        } else {
            htmlElement.classList.add('layout-menu-expanded');
            htmlElement.classList.remove('layout-menu-collapsed');
        }

        // Only add hover class if stored in localStorage
        if (isHovered) {
            htmlElement.classList.add('layout-menu-hover');
        }



        htmlElement.setAttribute('data-skin', 'default');
        htmlElement.setAttribute('data-bs-theme', 'light');
        htmlElement.setAttribute('data-assets-path', `${CDN_URL}/parki/app_theme/assets/`);
        htmlElement.setAttribute('data-template', 'vertical-menu-template-no-customizer');

        // Load scripts with improved handling
        const loadScriptsInOrder = async () => {
            
            // Script loading utility
            const loadScript = (src) => {
                return new Promise((resolve) => {
                    // Check if script already exists
                    if (document.querySelector(`script[src="${src}"]`)) {
                        resolve();
                        return;
                    }
                    
                    const script = document.createElement('script');
                    script.src = src;
                    script.async = false;
                    script.onload = resolve;
                    script.onerror = () => {
                        console.warn(`Failed to load script: ${src}`);
                        resolve(); // Continue despite errors
                    };
                    document.body.appendChild(script);
                });
            };

            // Core scripts to load in specific order
            const coreScripts = [
                `${CDN_URL}/parki/app_theme/assets/vendor/js/helpers.js`,
                `${CDN_URL}/parki/app_theme/assets/js/config.js`,
                `${CDN_URL}/parki/app_theme/assets/vendor/libs/jquery/jquery.js`,
                `${CDN_URL}/parki/app_theme/assets/vendor/libs/popper/popper.js`,
                `${CDN_URL}/parki/app_theme/assets/vendor/js/bootstrap.js`
            ];
            
            // Load core scripts sequentially
            for (const script of coreScripts) {
                await loadScript(script);
                await new Promise(r => setTimeout(r, 50)); // Small delay
            }
            
            // Additional scripts that can load in parallel
            const additionalScripts = [
                `${CDN_URL}/parki/app_theme/assets/vendor/libs/node-waves/node-waves.js`,
                `${CDN_URL}/parki/app_theme/assets/vendor/libs/perfect-scrollbar/perfect-scrollbar.js`,
                `${CDN_URL}/parki/app_theme/assets/vendor/libs/hammer/hammer.js`,
                `${CDN_URL}/parki/app_theme/assets/vendor/libs/i18n/i18n.js`,
                `${CDN_URL}/parki/app_theme/assets/vendor/js/menu.js`,
                `${CDN_URL}/parki/app_theme/assets/js/main.js`
            ];
            
            // Load additional scripts
            await Promise.all(additionalScripts.map(src => loadScript(src)));
            
            // Initialize menu after everything is loaded
            setTimeout(() => {
                if (window.Menu) {
                    try {
                        window.Menu.init();
                    } catch (e) {
                        console.warn('Menu initialization error:', e);
                    }
                }
            }, 200);
        };

        loadScriptsInOrder();

        // Cleanup function
        return () => {
            const scripts = document.querySelectorAll(`script[src^="${CDN_URL}"]`);
            scripts.forEach(script => {
                if (script.parentNode) script.parentNode.removeChild(script);
            });
            
            // Also remove our inline configuration script
            const inlineScript = document.querySelector('script:not([src])');
            if (inlineScript?.parentNode) {
                inlineScript.parentNode.removeChild(inlineScript);
            }
        };
    }, []);

    return null;
};

export default ScriptLoader;